import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { trackByValue } from '@y42/angular/util';
import { ColumnTypeEnum, OperatorEnum } from '@y42/json-schema';
import { SelectOption } from '@y42/util/select-option';
import { OperationInputFormService } from '../../operation-input-form.service';
import { AbsoluteDateRangePreset, RelativeDateRangePreset } from '../../operation-input.model';

@Component({
  selector: 'y42-operation-input-date-time[columnType]',
  templateUrl: './operation-input-date-time.component.html',
  styleUrls: ['./operation-input-date-time.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationInputDateTimeComponent {
  constructor(private readonly formService: OperationInputFormService) {}

  readonly trackByValue = trackByValue;

  @Input()
  columnType!: ColumnTypeEnum;

  @Input()
  showRelativeDates = false;

  @Input()
  enableMoreConditions = true;

  @Input()
  absoluteRangePresets?: AbsoluteDateRangePreset[];

  @Input()
  relativeRangePresets?: RelativeDateRangePreset[];

  @Input() operatorOptions?: Array<SelectOption<OperatorEnum>>;

  @Input() minDate?: Date;
  @Input() maxDate?: Date;

  readonly operationsFormArray = this.formService.operationsFormArray;
}
